<template>
<div>
  <div class="about-us">
    <el-container class="d-flex-column">
      <el-row :gutter="24">
        <el-col :span="12"><img src="../../../public/img/team/our-team.jpg" alt="team" class="img-responsive " ></el-col>
        <el-col :span="12">
          <h1>Our Team</h1>
          <p>Maren Solutions technologies is gifted with passel of youngsters with highly skilled capabilities of developing products and delivering on time. We have a team that includes people across our country knowing the ropes in their fields. We believe unity in diversity</p>
          <!-- <a href="javascript:void(0);">Read more</a> -->
        </el-col>
      </el-row>
    </el-container>
  </div>
    <el-container class="d-flex-column p-tb100">
        <el-carousel :interval="5000" arrow="always">
            <el-carousel-item >
                <div class="team-slide">
                    <div class="cont">
                        <h4 class="">Maren, a home of young passel folks from different streams</h4>
                        <h6>Business Analysts</h6>
                        <p>We have well adversed analysts to perform process modelling to  analyse the requirements with ease and freezes them with unique business strategic approach as per product lifecycle.</p>
                    </div>
                    <img src="../../../public/img/team/team.png" alt="team" class="img-responsive " >
                </div>
            </el-carousel-item>
             <el-carousel-item >
                <div class="team-slide">
                    <div class="cont">
                        
                        <h6>UI Designers</h6>
                        <p>We have our team of designers who are up to date with the latest design trend with user centric designs</p>
                    </div>
                    <img src="../../../public/img/team/team.png" alt="team" class="img-responsive">
                </div>
            </el-carousel-item>
            <el-carousel-item >
                <div class="team-slide">
                    <div class="cont">
                        <h6>Developers</h6>
                        <p>We have ample of  well experienced front end and back end developers who uses cutting edge technologies to develop the products </p>
                    </div>
                    <img src="../../../public/img/team/team.png" alt="team" class="img-responsive">
                </div>
            </el-carousel-item>
             <el-carousel-item >
                <div class="team-slide">
                    <div class="cont">
                        
                        <h6>Quality Analysts</h6>
                        <p>A dedicated  testing team who applies quality engineering principals to validate the applications and ensures to deliver bug-free product </p>
                    </div>
                    <img src="../../../public/img/team/team.png" alt="team" class="img-responsive">
                </div>
            </el-carousel-item>
        </el-carousel>
    </el-container>
</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
  export default {
  watch:{
    scobj:{
      immediate:true,
      deep: true,
      handler(){
        if(this.scobj){
          this.scobj = false
          var element = this.$refs['flightRef'];
          var top = element.offsetTop;
          window.scrollTo(0, top);
        }
      }
    }
  },
    computed: mapState(['currentLanguage']),
    title () {
      return this.currentLanguage == 'en' ? '' : ''
    },
    components:{  },
    data() {
      return {
        }
      },
      methods: {
        toggleBodyClass(addRemoveClass, className) {
          const el = document.body;

          if (addRemoveClass === 'addClass') {
            el.classList.add(className);
          } else {
            el.classList.remove(className);
          }
        },
      },
        mounted() {
          this.toggleBodyClass('addClass', 'team');
        },
        destroyed() {
          this.toggleBodyClass('removeClass', 'team');
        }
    };
</script>


// WEBPACK FOOTER //
// OurTeam.vue